// extracted by mini-css-extract-plugin
module.exports = {"template":"ReportTemplateListDialog_template_2QM-A"};